export default __webpack_public_path__ + "cb01e4faaf97f198fcca3b26a897624a.png";